// import React, { useEffect, useState } from "react";
// import { Table, Button, Collapse, Container } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchHierarchy } from "../../redux/slice/hierarchySlice";
// import { PropagateLoader } from "react-spinners";
// import "./ViewKendraTable.css";
// import fieldLabels from "../FiledLabels";
// import { JilaTranslation, VibhagTranslation, PrantTranslation, kshetraTranslation } from "../Fileds";

// import Loader from "../Loader/Loader"

// const CollapsibleTable = () => {
//   const dispatch = useDispatch();
//   const { data, loading, error } = useSelector((state) => state.hierarchy);

//   const language = useSelector((state) => state.language.language);

//   const user = useSelector((state) => state.auth.user);

//   const [openKshettra, setOpenKshettra] = useState({});
//   const [openPrant, setOpenPrant] = useState({});
//   const [openVibhag, setOpenVibhag] = useState({});

//   // const [selectedPrantId, setSelectedPrantId] = React.useState(null);

//   const [selectedKshettraId, setSelectedKshettraId] = useState(null);
//   const [selectedPrantId, setSelectedPrantId] = useState(null);
//   const [selectedVibhagId, setSelectedVibhagId] = useState(null);

//   // Function to handle row click
//   const handlePrantRowClick = (id, index, type) => {
//     if (type === "prant") {

//       setSelectedPrantId((prantId) => (prantId === id ? null : id));
//     } else if (type === "vibhag") {
//       setSelectedVibhagId((vibhagId) => (vibhagId === id ? null : id));
//     } else if (type === "kshettra") {
//       setSelectedKshettraId((kshettraId) => (kshettraId === id ? null : id));
//     }
//   };

//   useEffect(() => {
//     dispatch(fetchHierarchy());
//   }, [dispatch]);

//   const toggleKshettra = (name) =>
//     setOpenKshettra((prev) => ({ ...prev, [name]: !prev[name] }));
//   const togglePrant = (name) =>
//     setOpenPrant((prev) => ({ ...prev, [name]: !prev[name] }));
//   const toggleVibhag = (name) =>
//     setOpenVibhag((prev) => ({ ...prev, [name]: !prev[name] }));

//   const fieldGroups = [
//     { title: `${fieldLabels[language]?.mahanagar}`, count: 9 },
//     { title: `${fieldLabels[language]?.anyaNagar}`, count: 9 },
//     { title: `${fieldLabels[language]?.jilaKendra}`, count: 9 },
//     { title: `${fieldLabels[language]?.TableVillagesOver5000}`, count: 4 },
//     { title: `${fieldLabels[language]?.TableVillagesUnder5000}`, count: 2 },
//   ];

//   const [openFieldGroups, setOpenFieldGroups] = useState(
//     Array(fieldGroups.length).fill(true)
//   );

//   // const calculateGroupTotal = (groupIndex, kendra) => {
//   //   const startIndex = fieldGroups
//   //     .slice(0, groupIndex)
//   //     .reduce((sum, group) => sum + group.count, 0);
//   //   const endIndex = startIndex + fieldGroups[groupIndex].count;

//   //   let total = 0;
//   //   for (let i = startIndex; i < endIndex; i++) {
//   //     const fieldName = fieldNames[i];
//   //     total += calculateTotals([kendra], fieldName) || 0;
//   //   }
//   //   return total;
//   // };

//   // console.log("userTypeeeee",user.user_type_id);

//   // console.log("datatatatta",data[0]?.kshetras[2]?.prants[0]?.vibhags[0]?.jilas)
//   // console.log("datatatatta",data[0]?.kshetras[3]?.prants[0]?.vibhags[0])

//   const fieldNames = [
//     `${fieldLabels[language]?.districtNumber}`,
//     `${fieldLabels[language]?.settlementNumber}`,
//     `${fieldLabels[language]?.serviceSettlementNumber}`,
//     `${fieldLabels[language]?.businessCollegeNumber}`,
//     `${fieldLabels[language]?.settlementBranchNumber}`,
//     `${fieldLabels[language]?.serviceWorkerBranchNumber}`,
//     `${fieldLabels[language]?.totalServiceWorkers}`,
//     `${fieldLabels[language]?.totalServiceWork}`,
//     `${fieldLabels[language]?.monthlyContactNumber}`,
//     `${fieldLabels[language]?.districtNumber}`,
//     `${fieldLabels[language]?.settlementNumber}`,
//     `${fieldLabels[language]?.serviceSettlementNumber}`,
//     `${fieldLabels[language]?.businessCollegeNumber}`,
//     `${fieldLabels[language]?.settlementBranchNumber}`,
//     `${fieldLabels[language]?.serviceWorkerBranchNumber}`,
//     `${fieldLabels[language]?.totalServiceWorkers}`,
//     `${fieldLabels[language]?.totalServiceWork}`,
//     `${fieldLabels[language]?.monthlyContactNumber}`,
//     `${fieldLabels[language]?.districtNumber}`,
//     `${fieldLabels[language]?.settlementNumber}`,
//     `${fieldLabels[language]?.serviceSettlementNumber}`,
//     `${fieldLabels[language]?.businessCollegeNumber}`,
//     `${fieldLabels[language]?.settlementBranchNumber}`,
//     `${fieldLabels[language]?.serviceWorkerBranchNumber}`,
//     `${fieldLabels[language]?.totalServiceWorkers}`,
//     `${fieldLabels[language]?.totalServiceWork}`,
//     `${fieldLabels[language]?.monthlyContactNumber}`,
//     `${fieldLabels[language]?.villagesAbove5000}`,
//     `${fieldLabels[language]?.businessVillageNumber}`,
//     `${fieldLabels[language]?.serviceVillageNumber}`,
//     `${fieldLabels[language]?.totalServiceInVillages}`,
//     `${fieldLabels[language]?.villagesUnder5000}`,
//     `${fieldLabels[language]?.totalServiceInVillages}`,
//   ];

//   const getNestedData = (jila, fieldName) => {
//     if (!jila.reporting_form) return "-";

//     const {
//       mahanagar,
//       // jilaKendra,
//       // anyaNagar,
//       villagesOver5000,
//       villagesUnder5000,
//     } = jila.reporting_form;

//     switch (fieldName) {
//       case `${fieldLabels[language]?.districtNumber}`:
//         return mahanagar?.zila_sam_mahanagar_bhag_sankhya || "-";
//       case `${fieldLabels[language]?.settlementNumber}`:
//         return mahanagar?.sewa_basti_sankhya || "-";
//       case `${fieldLabels[language]?.serviceSettlementNumber}`  :
//         return mahanagar?.sewa_kary_yukt_sewa_basti || "-";
//       case `${fieldLabels[language]?.businessCollegeNumber}`:
//         return (
//           mahanagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya || "-"
//         );
//       case `${fieldLabels[language]?.settlementBranchNumber}`:
//         return mahanagar?.sewa_basti_palak_shakha_w_milan_sankhya || "-";
//       case `${fieldLabels[language]?.serviceWorkerBranchNumber}`:
//         return mahanagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "-";
//       case `${fieldLabels[language]?.totalServiceWorkers}`:
//         return mahanagar?.kul_sewa_karyakarta || "-";
//       case `${fieldLabels[language]?.totalServiceWork}`:
//         return mahanagar?.mahanagar_mein_kul_sewa_kary || "-";
//       case `${fieldLabels[language]?.monthlyContactNumber}`:
//         return (
//           mahanagar?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya ||
//           "-"
//         );
//       case `${fieldLabels[language]?.villagesAbove5000}`:
//         return villagesOver5000?.total_villages || "-";
//       case `${fieldLabels[language]?.businessVillageNumber}`:
//         return villagesOver5000?.business_and_farming_villages || "-";
//       case `${fieldLabels[language]?.serviceVillageNumber}`:
//         return villagesOver5000?.service_work_villages || "-";
//       case `${fieldLabels[language]?.totalServiceInVillages}`:
//         return villagesOver5000?.total_service_work || "-";
//       case `${fieldLabels[language]?.villagesUnder5000}`:
//         return villagesUnder5000?.service_work_villages || "-";
//       case `${fieldLabels[language]?.totalServiceInVillages}`:
//         return villagesUnder5000?.total_service_work || "-";
//       default:
//         return "-";
//     }
//   };

//   const calculateTotals = (data, fieldName) => {
//     return data.reduce((total, item) => {
//       if (item.jilas) {
//         return (
//           total +
//           item.jilas.reduce((jilaTotal, jila) => {
//             const value = getNestedData(jila, fieldName);
//             return jilaTotal + (value === "-" ? 0 : Number(value));
//           }, 0)
//         );
//       } else if (item.vibhags) {
//         return (
//           total +
//           item.vibhags.reduce(
//             (vibhagTotal, vibhag) =>
//               vibhagTotal + calculateTotals([vibhag], fieldName),
//             0
//           )
//         );
//       } else if (item.prants) {
//         return (
//           total +
//           item.prants.reduce(
//             (prantTotal, prant) =>
//               prantTotal + calculateTotals([prant], fieldName),
//             0
//           )
//         );
//       } else {
//         const value = getNestedData(item, fieldName);
//         return total + (value === "-" ? 0 : Number(value));
//       }
//     }, 0);
//   };

//   const calculateGrandTotal = (fieldName) => {
//     return data.reduce((total, kendra) => {
//       return (
//         total +
//         kendra.kshetras.reduce((kshettraTotal, kshettra) => {
//           return kshettraTotal + calculateTotals([kshettra], fieldName);
//         }, 0)
//       );
//     }, 0);
//   };

//   const toggleFieldGroup = (index) => {
//     setOpenFieldGroups((prev) => {
//       const updated = [...prev];
//       updated[index] = !updated[index];
//       return updated;
//     });
//   };

//   const filteredData = (() => {
//     if (user.user_type === "kendra") {
//       return data.filter(kendra => kendra._id === user.user_type_id);
//     }

//     if (user.user_type === "kshetra") {
//       return data
//         .flatMap(kendra => kendra.kshetras)
//         .filter(kshetra => kshetra._id === user.user_type_id);
//     }

//     if (user.user_type === "prant") {
//       return data
//         .flatMap(kendra => kendra.kshetras)
//         .flatMap(kshetra => kshetra.prants)
//         .filter(prant => prant._id === user.user_type_id);
//     }

//     if (user.user_type === "vibhag") {
//       return data
//         .flatMap(kendra => kendra.kshetras)
//         .flatMap(kshetra => kshetra.prants)
//         .flatMap(prant => prant.vibhags)
//         .filter(vibhag => vibhag._id === user.user_type_id);
//     }

//     if (user.user_type === "jila") {
//       return data
//         .flatMap(kendra => kendra.kshetras)
//         .flatMap(kshetras => kshetras.prants)
//         .flatMap(prant => prant.vibhags)
//         .flatMap(vibhag => vibhag.jilas)
//         .filter(jila => jila._id === user.user_type_id);
//     }

//     return [];
//   })();

//   const translateName = (name, translationMap) => {
//     if (language.trim() === "hindi" && translationMap[name]) {
//       return translationMap[name];
//     }
//     return name;
//   };

//   if (loading) return <PropagateLoader className="text-center" color="#ff6600" />;
//   if (error) return <p>Error: {error?.message}</p>;
//   if (loading || error) {
//     return <Loader loading={loading} error={error} />;
//   }

//   return (
//     <Container fluid className="mt-3">
//       <Table responsive bordered hover size="sm" className="custom-table">
//         <thead>
//           <tr>
//             <th rowSpan="2" className="fixed-header table-main-heading">
//             {fieldLabels[language]?.KshetraPrantVibahgJila}
//             </th>
//             {fieldGroups.map((group, index) => (
//               <th
//                 key={index}
//                 colSpan={group.count}
//                 className="fixed-header table-main-heading"
//                 onClick={() => toggleFieldGroup(index)}
//                 style={{
//                   cursor: "pointer",
//                   backgroundColor: "#f0f0f0",
//                   transition: "width 0.3s ease-in-out",
//                   width: openFieldGroups[index] ? "500px" : "1000px",
//                   textAlign: "center",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   display: "table-cell",
//                   minWidth: "300px",
//                   maxWidth: "800px",
//                   verticalAlign: "middle"
//                 }}

//               >
//               <span style={{ display: "inline-block", width: "100%" }}>
//               {group.title} {openFieldGroups[index] ? "▲" : "▼"}
//             </span>
//                 {/* {group.title} {openFieldGroups[index] ? "▲" : "▼"} */}
//               </th>
//             ))}
//           </tr>
//           <tr>
//           {fieldNames.map((name, index) => {

//               const groupIndex = fieldGroups.findIndex(
//                 (group, i) =>
//                   index >=
//                     fieldGroups
//                       .slice(0, i)
//                       .reduce((sum, g) => sum + g.count, 0) &&
//                   index <
//                     fieldGroups
//                       .slice(0, i + 1)
//                       .reduce((sum, g) => sum + g.count, 0)
//               );
//               return openFieldGroups[groupIndex] ? (
//                 <th key={index} className="fixed-header">
//                   {name}
//                 </th>
//               ) : (
//                 <th
//                   key={index}
//                   className="fixed-header"
//                   style={{ visibility: "hidden" }}
//                 >

//                 </th>
//               );
//             })}
//           </tr>
//         </thead>
//         <tbody>
//   {filteredData.map((item) => {
// const translatedJila = translateName(item.jila_name, JilaTranslation);
//     if (user.user_type === "jila") {
//       return (
//         <React.Fragment key={item._id}>
//           <tr className="jila-row">
//             <td>{translatedJila}</td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}>{getNestedData(item, fieldName)}</td>
//             ))}
//           </tr>
//           {/* Grand Total Row */}
//           <tr className="grand-total-row">
//             <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}><strong>{calculateTotals([item], fieldName)}</strong></td>
//             ))}
//           </tr>
//         </React.Fragment>
//       );
//     }

//     if (user.user_type === "vibhag") {
//       return (
//         <React.Fragment key={item._id}>

//           {item.jilas.map((jila) => {
//           const translatedJila = translateName(jila.jila_name, JilaTranslation);
//           return (
//             <tr key={jila._id} className="jila-row">
//               <td>{translatedJila}</td>
//               {fieldNames.map((fieldName, index) => (
//                 <td key={index}>{getNestedData(jila, fieldName)}</td>
//               ))}
//             </tr>
//           );
//         })}
//           {/* Grand Total Row */}
//           <tr className="grand-total-row">
//             <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}><strong>{calculateTotals(item.jilas, fieldName)}</strong></td>
//             ))}
//           </tr>
//         </React.Fragment>
//       );
//     }

//     if (user.user_type === "prant") {
//       return (
//         <React.Fragment key={item._id}>
//           {item.vibhags.map((vibhag) => {
//              const translatedVibhag = translateName(vibhag.vibhag_name, VibhagTranslation);
//              return (
//             <React.Fragment key={vibhag._id}>
//               <tr
//                 className="vibhag-row"
//                 style={{
//                   backgroundColor:
//                     selectedVibhagId === vibhag._id ? "#c2b4a0" : "transparent",
//                 }}
//                 onClick={() => handlePrantRowClick(vibhag._id, null, "vibhag")}
//               >
//                 <td>
//                   <Button variant="link" onClick={() => toggleVibhag(vibhag.vibhag_name)}>
//                   {translatedVibhag}
//                   </Button>
//                 </td>
//                 {fieldNames.map((fieldName, index) => (
//                   <td key={index}>{calculateTotals([vibhag], fieldName) || "-"}</td>
//                 ))}
//               </tr>
//               <tr>
//                 <td colSpan={fieldNames.length + 1}>
//                   <Collapse in={openVibhag[vibhag.vibhag_name]}>
//                     <div>
//                       <Table bordered size="sm" className="custom-table">
//                         <tbody>
//                           {vibhag.jilas.map((jila) => {
//                             const translatedJila = translateName(jila.jila_name, JilaTranslation);
//                             return (
//                             <tr key={jila._id} className="jila-row">
//                               <td>{translatedJila}</td>
//                               {fieldNames.map((fieldName, index) => (
//                                 <td key={index}>{getNestedData(jila, fieldName)}</td>
//                               ))}
//                             </tr>
//                            );
//                           })}
//                         </tbody>
//                       </Table>
//                     </div>
//                   </Collapse>
//                 </td>
//               </tr>
//             </React.Fragment>
//             );
//           })}
//           <tr className="grand-total-row">
//             <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}><strong>{calculateTotals(item.vibhags, fieldName)}</strong></td>
//             ))}
//           </tr>
//         </React.Fragment>
//       );
//     }
//     if (user.user_type === "kshetra") {
//       return (
//         <React.Fragment key={item._id}>
//           {item.prants.map((prant) => {
//             const translatedPrant = translateName(prant.prant_name, PrantTranslation);
//             return (
//             <React.Fragment key={prant._id}>
//               <tr
//                 className="prant-row"
//                 style={{
//                   backgroundColor:
//                     selectedPrantId === prant._id ? "#c2b4a0" : "transparent",
//                 }}
//                 onClick={() => handlePrantRowClick(prant._id, null, "prant")}
//               >
//                 <td>
//                   <Button variant="link" onClick={() => togglePrant(prant.prant_name)}>
//                   {translatedPrant}
//                   </Button>
//                 </td>
//                 {fieldNames.map((fieldName, index) => (
//                   <td key={index}>{calculateTotals([prant], fieldName) || "-"}</td>
//                 ))}
//               </tr>
//               <tr>
//                 <td colSpan={fieldNames.length + 1}>
//                   <Collapse in={openPrant[prant.prant_name]}>
//                     <div>
//                       <Table bordered size="sm" className="custom-table">
//                         <tbody>
//                           {prant.vibhags.map((vibhag) => {
//                               const translatedVibhag = translateName(vibhag.vibhag_name, VibhagTranslation);
//                               return (
//                             <React.Fragment key={vibhag._id}>
//                               <tr
//                                 className="vibhag-row"
//                                 style={{
//                                   backgroundColor:
//                                     selectedVibhagId === vibhag._id ? "#54c0a1" : "transparent",
//                                 }}
//                                 onClick={() => handlePrantRowClick(vibhag._id, null, "vibhag")}
//                               >
//                                 <td>
//                                   <Button variant="link" onClick={() => toggleVibhag(vibhag.vibhag_name)}>
//                                   {translatedVibhag}
//                                   </Button>
//                                 </td>
//                                 {fieldNames.map((fieldName, index) => (
//                                   <td key={index}>
//                                     {calculateTotals([vibhag], fieldName) || "-"}
//                                   </td>
//                                 ))}
//                               </tr>
//                               {/* jila_row added */}
//                               <tr>
//                             <td colSpan={fieldNames.length + 1}>
//                               <Collapse in={openVibhag[vibhag.vibhag_name]}>
//                                 <div>
//                                   <Table bordered size="sm" className="custom-table">
//                                     <tbody>
//                                       {vibhag.jilas && vibhag.jilas.length > 0 ? (
//                                         vibhag.jilas.map((jila) => {
//                                           const translatedJila = translateName(jila.jila_name, JilaTranslation);
//                                           return (

//                                           <tr
//                                             key={jila._id}
//                                             className="jila-row"
//                                             style={{
//                                               backgroundColor: jila._id ? "#f4a261" : "transparent",
//                                             }}
//                                             onClick={() => handlePrantRowClick(jila._id, null, "jila")}
//                                           >
//                                             <td>
//                                               <Button variant="link">{translatedJila}</Button>
//                                             </td>
//                                             {fieldNames.map((fieldName, index) => (
//                                               <td key={index}>{getNestedData(jila, fieldName) || "-"}</td>
//                                             ))}
//                                           </tr>
//                                          );
//                                         })
//                                       ) : (
//                                         <tr>
//                                           <td colSpan={fieldNames.length + 1} style={{ textAlign: "center" }}>
//                                             No Jila Available
//                                           </td>
//                                         </tr>
//                                       )}
//                                     </tbody>
//                                   </Table>
//                                 </div>
//                               </Collapse>
//                             </td>
//                           </tr>
//                            {/* jila_row end */}
//                             </React.Fragment>
//                     );
//                   })}
//                         </tbody>
//                       </Table>
//                     </div>
//                   </Collapse>
//                 </td>
//               </tr>
//             </React.Fragment>
//            );
//         })}
//           {/* Grand Total Row */}
//           <tr className="grand-total-row">
//             <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}><strong>{calculateTotals(item.prants, fieldName)}</strong></td>
//             ))}
//           </tr>
//         </React.Fragment>
//       );
//     }

//     return (
//       <React.Fragment key={item._id}>
//         {item.kshetras.map((kshettra) => (
//           <React.Fragment key={kshettra._id}>
//             <tr
//               className="kshettra-row"
//               style={{
//                 backgroundColor: selectedKshettraId === kshettra._id ? "#dcbc44" : "transparent",
//               }}
//               onClick={() => handlePrantRowClick(kshettra._id, null, "kshetra")}
//             >
//               <td>
//                 <Button variant="link" onClick={() => toggleKshettra(kshettra.kshetra_name)}>
//                   {kshettra.kshetra_name}
//                 </Button>
//               </td>
//               {fieldNames.map((fieldName, index) => (
//                 <td key={index}>{calculateTotals([kshettra], fieldName) || "-"}</td>
//               ))}
//             </tr>
//           </React.Fragment>
//         ))}
//         {/* Grand Total Row */}
//         <tr className="grand-total-row">
//           <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
//           {fieldNames.map((fieldName, index) => (
//             <td key={index}><strong>{calculateTotals(item.kshetras, fieldName)}</strong></td>
//           ))}
//         </tr>
//       </React.Fragment>
//     );
//   })}
// </tbody>

// {user.user_type === "kendra" && (
//   <tbody>
//     {data.map((kendra) =>
//       kendra.kshetras.map((kshettra, index) => {
//         const translatedKshetra = translateName(kshettra.kshetra_name, kshetraTranslation);
//         return (
//         <React.Fragment key={kshettra._id}>
//           <tr
//             className="kshettra-row"
//             style={{
//               backgroundColor:
//                 selectedKshettraId === kshettra._id ? "#eeaeca" : "transparent",
//             }}
//             onClick={() => handlePrantRowClick(kshettra._id, index, "kshettra")}
//           >
//             <td>
//               <Button
//                 variant="link"
//                 onClick={() => toggleKshettra(kshettra.kshetra_name)}
//               >
//                  {translatedKshetra}
//               </Button>
//             </td>
//             {fieldNames.map((fieldName, index) => (
//               <td key={index}>{calculateTotals([kshettra], fieldName) || "-"}</td>
//             ))}
//           </tr>
//           <tr>
//             <td colSpan={fieldNames.length + 1}>
//               <Collapse in={openKshettra[kshettra.kshetra_name]}>
//                 <div>
//                   <Table bordered size="sm" className="custom-table">
//                     <tbody>
//                       {kshettra.prants.map((prant, index) => {
//                           const translatedPrant = translateName(prant.prant_name, PrantTranslation);
//                           return (
//                         <React.Fragment key={prant._id}>
//                           <tr
//                             className="prant-row"
//                             style={{
//                               backgroundColor:
//                                 selectedPrantId === prant._id
//                                   ? "#42cef5"
//                                   : "transparent",
//                             }}
//                             onClick={() => handlePrantRowClick(prant._id, index, "prant")}
//                           >
//                             <td>
//                               <Button
//                                 variant="link"
//                                 onClick={() => togglePrant(prant.prant_name)}
//                               >
//                                 {translatedPrant}
//                               </Button>
//                             </td>
//                             {fieldNames.map((fieldName, index) => (
//                               <td key={index}>
//                                 {calculateTotals([prant], fieldName) || "-"}
//                               </td>
//                             ))}
//                           </tr>
//                           <tr>
//                             <td colSpan={fieldNames.length + 1}>
//                               <Collapse in={openPrant[prant.prant_name]}>
//                                 <div>
//                                   <Table bordered size="sm" className="custom-table">
//                                     <tbody>
//                                       {prant.vibhags.map((vibhag, index) => {
//                                        const translatedVibhag = translateName(vibhag.vibhag_name, VibhagTranslation);
//                                        return (
//                                         <React.Fragment key={vibhag._id}>
//                                           <tr
//                                             className="vibhag-row"
//                                             style={{
//                                               backgroundColor:
//                                                 selectedVibhagId === vibhag._id
//                                                   ? "#907c56"
//                                                   : "transparent",
//                                             }}
//                                             onClick={() => handlePrantRowClick(vibhag._id, index, "vibhag")}
//                                           >
//                                             <td>
//                                               <Button
//                                                 variant="link"
//                                                 onClick={() => toggleVibhag(vibhag.vibhag_name)}
//                                               >
//                                                 {translatedVibhag}
//                                               </Button>
//                                             </td>
//                                             {fieldNames.map((fieldName, index) => (
//                                               <td key={index}>
//                                                 {calculateTotals([vibhag], fieldName) || "-"}
//                                               </td>
//                                             ))}
//                                           </tr>
//                                           <tr>
//                                             <td colSpan={fieldNames.length + 1}>
//                                               <Collapse in={openVibhag[vibhag.vibhag_name]}>
//                                                 <div>
//                                                   <Table bordered size="sm" className="custom-table">
//                                                     <tbody>
//                                                       {vibhag.jilas.map((jila) => {
//                                                            const translatedJila = translateName(jila.jila_name, JilaTranslation);
//                                                            return (
//                                                         <tr key={jila._id} className="jila-row">
//                                                           <td>{translatedJila}</td>
//                                                           {fieldNames.map((fieldName, index) => (
//                                                             <td key={index}>
//                                                               {getNestedData(jila, fieldName)}
//                                                             </td>
//                                                           ))}
//                                                         </tr>
//                                                        );
//                                                       })}
//                                                     </tbody>
//                                                   </Table>
//                                                 </div>
//                                               </Collapse>
//                                             </td>
//                                           </tr>
//                                         </React.Fragment>
//                                       );
//                                     })}
//                                     </tbody>
//                                   </Table>
//                                 </div>
//                               </Collapse>
//                             </td>
//                           </tr>
//                         </React.Fragment>
//                     );
//                   })}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Collapse>
//             </td>
//           </tr>
//         </React.Fragment>
//       );
//     })
//   )}
//     {/* Grand Total Row */}
//     <tr>
//       <td className="fixed-header">{fieldLabels[language]?.GrandTotal}</td>
//       {fieldNames.map((fieldName, index) => (
//         <td key={index}>{calculateGrandTotal(fieldName) || "-"}</td>
//       ))}
//     </tr>
//   </tbody>
// )}

//       </Table>
//     </Container>
//   );
// };

// export default CollapsibleTable;

import React, { useEffect, useState } from "react";
import { Table, Button, Collapse, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchHierarchy } from "../../redux/slice/hierarchySlice";
import { PropagateLoader } from "react-spinners";
import "./ViewKendraTable.css";
import fieldLabels from "../FiledLabels";
import {
  JilaTranslation,
  VibhagTranslation,
  PrantTranslation,
  kshetraTranslation,
} from "../Fileds";

import Loader from "../Loader/Loader";

const CollapsibleTable = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.hierarchy);

  const language = useSelector((state) => state.language.language);

  const user = useSelector((state) => state.auth.user);

  const [openKshettra, setOpenKshettra] = useState({});
  const [openPrant, setOpenPrant] = useState({});
  const [openVibhag, setOpenVibhag] = useState({});

  // const [selectedPrantId, setSelectedPrantId] = React.useState(null);

  const [selectedKshettraId, setSelectedKshettraId] = useState(null);
  const [selectedPrantId, setSelectedPrantId] = useState(null);
  const [selectedVibhagId, setSelectedVibhagId] = useState(null);

  // Function to handle row click
  const handlePrantRowClick = (id, index, type) => {
    if (type === "prant") {
      setSelectedPrantId((prantId) => (prantId === id ? null : id));
    } else if (type === "vibhag") {
      setSelectedVibhagId((vibhagId) => (vibhagId === id ? null : id));
    } else if (type === "kshettra") {
      setSelectedKshettraId((kshettraId) => (kshettraId === id ? null : id));
    }
  };

  useEffect(() => {
    dispatch(fetchHierarchy());
  }, [dispatch]);

  const toggleKshettra = (name) =>
    setOpenKshettra((prev) => ({ ...prev, [name]: !prev[name] }));
  const togglePrant = (name) =>
    setOpenPrant((prev) => ({ ...prev, [name]: !prev[name] }));
  const toggleVibhag = (name) =>
    setOpenVibhag((prev) => ({ ...prev, [name]: !prev[name] }));

  const fieldGroups = [
    { title: `${fieldLabels[language]?.mahanagar}`, count: 11 },
    { title: `${fieldLabels[language]?.jilaKendra}`, count: 11 },
    { title: `${fieldLabels[language]?.anyaNagar}`, count: 9 },
    { title: `${fieldLabels[language]?.TableVillagesOver5000}`, count: 8 },
    { title: `${fieldLabels[language]?.TableVillagesUnder5000}`, count: 2 },
    { title: `${fieldLabels[language].sevaShikshanWorkReport}`, count: 7 },
  ];

  const [openFieldGroups, setOpenFieldGroups] = useState(
    Array(fieldGroups.length).fill(true)
  );

  // const calculateGroupTotal = (groupIndex, kendra) => {
  //   const startIndex = fieldGroups
  //     .slice(0, groupIndex)
  //     .reduce((sum, group) => sum + group.count, 0);
  //   const endIndex = startIndex + fieldGroups[groupIndex].count;

  //   let total = 0;
  //   for (let i = startIndex; i < endIndex; i++) {
  //     const fieldName = fieldNames[i];
  //     total += calculateTotals([kendra], fieldName) || 0;
  //   }
  //   return total;
  // };

  // console.log("userTypeeeee",user.user_type_id);

  // console.log("datatatatta",data[0]?.kshetras[2]?.prants[0]?.vibhags[0]?.jilas)
  // console.log("datatatatta",data[0]?.kshetras[3]?.prants[0]?.vibhags[0])

  const fieldNames = [
    // Mahanagar Fields
    `${fieldLabels[language]?.districtNumber}_mahanagar`,
    `${fieldLabels[language]?.settlementNumber}_mahanagar`,
    `${fieldLabels[language]?.serviceSettlementNumber}_mahanagar`,
    `${fieldLabels[language]?.businessCollegeNumber}_mahanagar`,
    `${fieldLabels[language]?.settlementBranchNumber}_mahanagar`,
    `${fieldLabels[language]?.serviceWorkerBranchNumber}_mahanagar`,
    `${fieldLabels[language]?.totalServiceWorkers}_mahanagar`,
    `${fieldLabels[language]?.totalServiceWork}_mahanagar`,
    `${fieldLabels[language]?.monthlyContactNumber}_mahanagar`,
    `${fieldLabels[language]?.totalMetropolitanCities}_mahanagar`,
    `${fieldLabels[language]?.functionalMetropolitanCities}_mahanagar`,

    // Jila Kendra Fields
    `${fieldLabels[language]?.districtNumber}_jilaKendra`,
    `${fieldLabels[language]?.settlementNumber}_jilaKendra`,
    `${fieldLabels[language]?.serviceSettlementNumber}_jilaKendra`,
    `${fieldLabels[language]?.businessCollegeNumber}_jilaKendra`,
    `${fieldLabels[language]?.settlementBranchNumber}_jilaKendra`,
    `${fieldLabels[language]?.serviceWorkerBranchNumber}_jilaKendra`,
    `${fieldLabels[language]?.totalServiceWorkers}_jilaKendra`,
    `${fieldLabels[language]?.totalServiceWork}_jilaKendra`,
    `${fieldLabels[language]?.monthlyContactNumber}_jilaKendra`,
    `${fieldLabels[language]?.totalBlocks}_jilaKendra`,
    `${fieldLabels[language]?.blocksWithServices}_jilaKendra`,

    // Anya Nagar Fields
    `${fieldLabels[language]?.districtNumber}_anyaNagar`,
    `${fieldLabels[language]?.settlementNumber}_anyaNagar`,
    `${fieldLabels[language]?.serviceSettlementNumber}_anyaNagar`,
    `${fieldLabels[language]?.businessCollegeNumber}_anyaNagar`,
    `${fieldLabels[language]?.settlementBranchNumber}_anyaNagar`,
    `${fieldLabels[language]?.serviceWorkerBranchNumber}_anyaNagar`,
    `${fieldLabels[language]?.totalServiceWorkers}_anyaNagar`,
    `${fieldLabels[language]?.totalServiceWork}_anyaNagar`,
    `${fieldLabels[language]?.monthlyContactNumber}_anyaNagar`,

    // Villages above 5000
    `${fieldLabels[language]?.villagesAbove5000}`,
    `${fieldLabels[language]?.serviceSettlementsAmongThem}_villagesAbove5000`,
    `${fieldLabels[language]?.businessVillageNumber}`,
    `${fieldLabels[language]?.serviceVillageNumber}`,
    `${fieldLabels[language]?.branchesMeetingsWithServiceWorkers}_villagesAbove5000`,
    `${fieldLabels[language]?.totalServiceWorkersInVillages}_villagesAbove5000`,
    `${fieldLabels[language]?.totalServiceInVillages}_villagesAbove5000`,
    `${fieldLabels[language]?.monthlyContactNumber}_villagesAbove5000`,

    // Villages under 5000
    `${fieldLabels[language]?.villagesUnder5000}`,
    `${fieldLabels[language]?.totalServiceInVillages}`,

    // sewa shikshan
    `${fieldLabels[language].sevaSanskar1}`,
    `${fieldLabels[language].sevaSanskar2}`,
    `${fieldLabels[language].augustSeptember}`,
    `${fieldLabels[language].branchesVisiting6Plus}`,
    `${fieldLabels[language].branchesConductingServiceActivities}`,
    `${fieldLabels[language].numberOfServiceActivitiesConducted}`,
    `${fieldLabels[language].serviceInitiativeBranch}`,
  ];

  const getNestedData = (jila, fieldName) => {
    if (!jila.reporting_form) return "-";

    const {
      mahanagar,
      jilaKendra,
      anyaNagar,
      villagesOver5000,
      villagesUnder5000,
      sevaShikshanKaryaVritt,
    } = jila.reporting_form;

    switch (fieldName) {
      // Mahanagar
      case `${fieldLabels[language]?.districtNumber}_mahanagar`:
        return mahanagar?.zila_sam_mahanagar_bhag_sankhya || "-";
      case `${fieldLabels[language]?.settlementNumber}_mahanagar`:
        return mahanagar?.sewa_basti_sankhya || "-";
      case `${fieldLabels[language]?.serviceSettlementNumber}_mahanagar`:
        return mahanagar?.sewa_kary_yukt_sewa_basti || "-";
      case `${fieldLabels[language]?.businessCollegeNumber}_mahanagar`:
        return (
          mahanagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya || "-"
        );
      case `${fieldLabels[language]?.settlementBranchNumber}_mahanagar`:
        return mahanagar?.sewa_basti_palak_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.serviceWorkerBranchNumber}_mahanagar`:
        return mahanagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.totalServiceWorkers}_mahanagar`:
        return mahanagar?.kul_sewa_karyakarta || "-";
      case `${fieldLabels[language]?.totalServiceWork}_mahanagar`:
        return mahanagar?.mahanagar_mein_kul_sewa_kary || "-";
      case `${fieldLabels[language]?.monthlyContactNumber}_mahanagar`:
        return (
          mahanagar?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya ||
          "-"
        );

      case `${fieldLabels[language]?.totalMetropolitanCities}_mahanagar`:
        return mahanagar?.kul_mahanagariy_nagar_sankhya || "-";
      case `${fieldLabels[language]?.functionalMetropolitanCities}_mahanagar`:
        return mahanagar?.seva_karyayukt_mahanagariy_nagar_sankhya || "-";

      // Jila Kendra
      case `${fieldLabels[language]?.districtNumber}_jilaKendra`:
        return jilaKendra?.zila_sam_jila_kendra_bhag_sankhya || "-";
      case `${fieldLabels[language]?.settlementNumber}_jilaKendra`:
        return jilaKendra?.inmein_sewa_basti_sankhya || "-";
      case `${fieldLabels[language]?.serviceSettlementNumber}_jilaKendra`:
        return jilaKendra?.sewa_kary_yukt_sewa_basti || "-";
      case `${fieldLabels[language]?.businessCollegeNumber}_jilaKendra`:
        return (
          jilaKendra?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya || "-"
        );
      case `${fieldLabels[language]?.settlementBranchNumber}_jilaKendra`:
        return jilaKendra?.sewa_basti_palak_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.serviceWorkerBranchNumber}_jilaKendra`:
        return jilaKendra?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.totalServiceWorkers}_jilaKendra`:
        return jilaKendra?.kul_sewa_karyakarta || "-";
      case `${fieldLabels[language]?.totalServiceWork}_jilaKendra`:
        return jilaKendra?.jila_kendra_mein_kul_sewa_kary || "-";
      case `${fieldLabels[language]?.monthlyContactNumber}_jilaKendra`:
        return (
          jilaKendra?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya ||
          "-"
        );

      case `${fieldLabels[language]?.totalBlocks}_jilaKendra`:
        return jilaKendra?.kul_khand || "-";
      case `${fieldLabels[language]?.blocksWithServices}_jilaKendra`:
        return jilaKendra?.seva_yukt_khand || "-";

      // Anya Nagar
      case `${fieldLabels[language]?.districtNumber}_anyaNagar`:
        return anyaNagar?.zila_sam_anya_nagar_bhag_sankhya || "-";
      case `${fieldLabels[language]?.settlementNumber}_anyaNagar`:
        return anyaNagar?.inmein_sewa_basti_sankhya || "-";
      case `${fieldLabels[language]?.serviceSettlementNumber}_anyaNagar`:
        return anyaNagar?.sewa_kary_yukt_sewa_basti || "-";
      case `${fieldLabels[language]?.businessCollegeNumber}_anyaNagar`:
        return (
          anyaNagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya || "-"
        );
      case `${fieldLabels[language]?.settlementBranchNumber}_anyaNagar`:
        return anyaNagar?.sewa_basti_palak_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.serviceWorkerBranchNumber}_anyaNagar`:
        return anyaNagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "-";
      case `${fieldLabels[language]?.totalServiceWorkers}_anyaNagar`:
        return anyaNagar?.kul_sewa_karyakarta || "-";
      case `${fieldLabels[language]?.totalServiceWork}_anyaNagar`:
        return anyaNagar?.anya_nagar_mein_kul_sewa_kary || "-";
      case `${fieldLabels[language]?.monthlyContactNumber}_anyaNagar`:
        return (
          anyaNagar?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya ||
          "-"
        );

      // Villages Above 5000
      case `${fieldLabels[language]?.villagesAbove5000}`:
        return villagesOver5000?.total_villages || "-";
      case `${fieldLabels[language]?.serviceSettlementsAmongThem}_villagesAbove5000`:
        return villagesOver5000?.inmein_seva_basti_ki_sankhya || "-";
      case `${fieldLabels[language]?.businessVillageNumber}`:
        return villagesOver5000?.business_and_farming_villages || "-";
      case `${fieldLabels[language]?.serviceVillageNumber}`:
        return villagesOver5000?.service_work_villages || "-";
      case `${fieldLabels[language]?.totalServiceInVillages}_villagesAbove5000`:
        return villagesOver5000?.total_service_work || "-";
      case `${fieldLabels[language]?.branchesMeetingsWithServiceWorkers}_villagesAbove5000`:
        return (
          villagesOver5000?.seva_karyakarta_yukt_shakha_va_milan_sankhya || "-"
        );
      case `${fieldLabels[language]?.totalServiceWorkersInVillages}_villagesAbove5000`:
        return villagesOver5000?.kul_seva_karyakarta || "-";
      case `${fieldLabels[language]?.monthlyContactNumber}_villagesAbove5000`:
        return (
          villagesOver5000?.masik_seva_basti_sampark_karne_wali_shakha || "-"
        );

      // Villages Under 5000
      case `${fieldLabels[language]?.villagesUnder5000}`:
        return villagesUnder5000?.service_work_villages || "-";
      case `${fieldLabels[language]?.totalServiceInVillages}`:
        return villagesUnder5000?.total_service_work || "-";

      //new fileds
      case `${fieldLabels[language].sevaSanskar1}`:
        return sevaShikshanKaryaVritt?.seva_sanskar_1 || "-";
      case `${fieldLabels[language].sevaSanskar2}`:
        return sevaShikshanKaryaVritt?.seva_sanskar_2 || "-";
      case `${fieldLabels[language].augustSeptember}`:
        return sevaShikshanKaryaVritt?.august_september || "-";
      case `${fieldLabels[language].branchesVisiting6Plus}`:
        return sevaShikshanKaryaVritt?.branches_visiting_6_plus || "-";
      case `${fieldLabels[language].branchesConductingServiceActivities}`:
        return (
          sevaShikshanKaryaVritt?.branches_conducting_service_activities || "-"
        );
      case `${fieldLabels[language].numberOfServiceActivitiesConducted}`:
        return (
          sevaShikshanKaryaVritt?.number_of_service_activities_by_branch || "-"
        );
      case `${fieldLabels[language].serviceInitiativeBranch}`:
        return sevaShikshanKaryaVritt?.service_initiative_branch || "-";

      default:
        return "-";
    }
  };

  const calculateTotals = (data, fieldName) => {
    return data.reduce((total, item) => {
      if (item.jilas) {
        return (
          total +
          item.jilas.reduce((jilaTotal, jila) => {
            const value = getNestedData(jila, fieldName);
            return jilaTotal + (value === "-" ? 0 : Number(value));
          }, 0)
        );
      } else if (item.vibhags) {
        return (
          total +
          item.vibhags.reduce(
            (vibhagTotal, vibhag) =>
              vibhagTotal + calculateTotals([vibhag], fieldName),
            0
          )
        );
      } else if (item.prants) {
        return (
          total +
          item.prants.reduce(
            (prantTotal, prant) =>
              prantTotal + calculateTotals([prant], fieldName),
            0
          )
        );
      } else {
        const value = getNestedData(item, fieldName);
        return total + (value === "-" ? 0 : Number(value));
      }
    }, 0);
  };

  const calculateGrandTotal = (fieldName) => {
    return data.reduce((total, kendra) => {
      return (
        total +
        kendra.kshetras.reduce((kshettraTotal, kshettra) => {
          return kshettraTotal + calculateTotals([kshettra], fieldName);
        }, 0)
      );
    }, 0);
  };

  const toggleFieldGroup = (index) => {
    setOpenFieldGroups((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  const filteredData = (() => {
    if (user.user_type === "kendra") {
      return data.filter((kendra) => kendra._id === user.user_type_id);
    }

    if (user.user_type === "kshetra") {
      return data
        .flatMap((kendra) => kendra.kshetras)
        .filter((kshetra) => kshetra._id === user.user_type_id);
    }

    if (user.user_type === "prant") {
      return data
        .flatMap((kendra) => kendra.kshetras)
        .flatMap((kshetra) => kshetra.prants)
        .filter((prant) => prant._id === user.user_type_id);
    }

    if (user.user_type === "vibhag") {
      return data
        .flatMap((kendra) => kendra.kshetras)
        .flatMap((kshetra) => kshetra.prants)
        .flatMap((prant) => prant.vibhags)
        .filter((vibhag) => vibhag._id === user.user_type_id);
    }

    if (user.user_type === "jila") {
      return data
        .flatMap((kendra) => kendra.kshetras)
        .flatMap((kshetras) => kshetras.prants)
        .flatMap((prant) => prant.vibhags)
        .flatMap((vibhag) => vibhag.jilas)
        .filter((jila) => jila._id === user.user_type_id);
    }

    return [];
  })();

  const translateName = (name, translationMap) => {
    if (language.trim() === "hindi" && translationMap[name]) {
      return translationMap[name];
    }
    return name;
  };

  if (loading)
    return <PropagateLoader className="text-center" color="#ff6600" />;
  if (error) return <p>Error: {error?.message}</p>;
  if (loading || error) {
    return <Loader loading={loading} error={error} />;
  }

  return (
    <Container fluid className="mt-3">
      <Table responsive bordered hover size="sm" className="custom-table">
        <thead>
          <tr>
            <th rowSpan="2" className="fixed-header table-main-heading">
              {fieldLabels[language]?.KshetraPrantVibahgJila}
            </th>
            {fieldGroups.map((group, index) => (
              <th
                key={index}
                colSpan={group.count}
                className="fixed-header table-main-heading"
                onClick={() => toggleFieldGroup(index)}
                style={{
                  cursor: "pointer",
                  backgroundColor: "#f0f0f0",
                  transition: "width 0.3s ease-in-out",
                  width: openFieldGroups[index] ? "500px" : "1000px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "table-cell",
                  minWidth: "300px",
                  maxWidth: "800px",
                  verticalAlign: "middle",
                }}
              >
                <span style={{ display: "inline-block", width: "100%" }}>
                  {group.title} {openFieldGroups[index] ? "▲" : "▼"}
                </span>
                {/* {group.title} {openFieldGroups[index] ? "▲" : "▼"} */}
              </th>
            ))}
          </tr>
          <tr>
            {fieldNames.map((name, index) => {
              const groupIndex = fieldGroups.findIndex(
                (group, i) =>
                  index >=
                    fieldGroups
                      .slice(0, i)
                      .reduce((sum, g) => sum + g.count, 0) &&
                  index <
                    fieldGroups
                      .slice(0, i + 1)
                      .reduce((sum, g) => sum + g.count, 0)
              );
              return openFieldGroups[groupIndex] ? (
                <th key={index} className="fixed-header">
                  {name}
                </th>
              ) : (
                <th
                  key={index}
                  className="fixed-header"
                  style={{ visibility: "hidden" }}
                ></th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((item) => {
            const translatedJila = translateName(
              item.jila_name,
              JilaTranslation
            );
            if (user.user_type === "jila") {
              return (
                <React.Fragment key={item._id}>
                  <tr className="jila-row">
                    <td>{translatedJila}</td>
                    {fieldNames.map((fieldName, index) => (
                      <td key={index}>{getNestedData(item, fieldName)}</td>
                    ))}
                  </tr>
                  {/* Grand Total Row */}
                  <tr className="grand-total-row">
                    <td>
                      <strong>{fieldLabels[language]?.GrandTotal}</strong>
                    </td>
                    {fieldNames.map((fieldName, index) => (
                      <td key={index}>
                        <strong>{calculateTotals([item], fieldName)}</strong>
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            }

            if (user.user_type === "vibhag") {
              return (
                <React.Fragment key={item._id}>
                  {item.jilas.map((jila) => {
                    const translatedJila = translateName(
                      jila.jila_name,
                      JilaTranslation
                    );
                    return (
                      <tr key={jila._id} className="jila-row">
                        <td>{translatedJila}</td>
                        {fieldNames.map((fieldName, index) => (
                          <td key={index}>{getNestedData(jila, fieldName)}</td>
                        ))}
                      </tr>
                    );
                  })}
                  {/* Grand Total Row */}
                  <tr className="grand-total-row">
                    <td>
                      <strong>{fieldLabels[language]?.GrandTotal}</strong>
                    </td>
                    {fieldNames.map((fieldName, index) => (
                      <td key={index}>
                        <strong>
                          {calculateTotals(item.jilas, fieldName)}
                        </strong>
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            }

            if (user.user_type === "prant") {
              return (
                <React.Fragment key={item._id}>
                  {item.vibhags.map((vibhag) => {
                    const translatedVibhag = translateName(
                      vibhag.vibhag_name,
                      VibhagTranslation
                    );
                    return (
                      <React.Fragment key={vibhag._id}>
                        <tr
                          className="vibhag-row"
                          style={{
                            backgroundColor:
                              selectedVibhagId === vibhag._id
                                ? "#c2b4a0"
                                : "transparent",
                          }}
                          onClick={() =>
                            handlePrantRowClick(vibhag._id, null, "vibhag")
                          }
                        >
                          <td>
                            <Button
                              variant="link"
                              onClick={() => toggleVibhag(vibhag.vibhag_name)}
                            >
                              {translatedVibhag}
                            </Button>
                          </td>
                          {fieldNames.map((fieldName, index) => (
                            <td key={index}>
                              {calculateTotals([vibhag], fieldName) || "-"}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td colSpan={fieldNames.length + 1}>
                            <Collapse in={openVibhag[vibhag.vibhag_name]}>
                              <div>
                                <Table
                                  bordered
                                  size="sm"
                                  className="custom-table"
                                >
                                  <tbody>
                                    {vibhag.jilas.map((jila) => {
                                      const translatedJila = translateName(
                                        jila.jila_name,
                                        JilaTranslation
                                      );
                                      return (
                                        <tr key={jila._id} className="jila-row">
                                          <td>{translatedJila}</td>
                                          {fieldNames.map(
                                            (fieldName, index) => (
                                              <td key={index}>
                                                {getNestedData(jila, fieldName)}
                                              </td>
                                            )
                                          )}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </Collapse>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  <tr className="grand-total-row">
                    <td>
                      <strong>{fieldLabels[language]?.GrandTotal}</strong>
                    </td>
                    {fieldNames.map((fieldName, index) => (
                      <td key={index}>
                        <strong>
                          {calculateTotals(item.vibhags, fieldName)}
                        </strong>
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            }
            if (user.user_type === "kshetra") {
              return (
                <React.Fragment key={item._id}>
                  {item.prants.map((prant) => {
                    const translatedPrant = translateName(
                      prant.prant_name,
                      PrantTranslation
                    );
                    return (
                      <React.Fragment key={prant._id}>
                        <tr
                          className="prant-row"
                          style={{
                            backgroundColor:
                              selectedPrantId === prant._id
                                ? "#c2b4a0"
                                : "transparent",
                          }}
                          onClick={() =>
                            handlePrantRowClick(prant._id, null, "prant")
                          }
                        >
                          <td>
                            <Button
                              variant="link"
                              onClick={() => togglePrant(prant.prant_name)}
                            >
                              {translatedPrant}
                            </Button>
                          </td>
                          {fieldNames.map((fieldName, index) => (
                            <td key={index}>
                              {calculateTotals([prant], fieldName) || "-"}
                            </td>
                          ))}
                        </tr>
                        <tr>
                          <td colSpan={fieldNames.length + 1}>
                            <Collapse in={openPrant[prant.prant_name]}>
                              <div>
                                <Table
                                  bordered
                                  size="sm"
                                  className="custom-table"
                                >
                                  <tbody>
                                    {prant.vibhags.map((vibhag) => {
                                      const translatedVibhag = translateName(
                                        vibhag.vibhag_name,
                                        VibhagTranslation
                                      );
                                      return (
                                        <React.Fragment key={vibhag._id}>
                                          <tr
                                            className="vibhag-row"
                                            style={{
                                              backgroundColor:
                                                selectedVibhagId === vibhag._id
                                                  ? "#54c0a1"
                                                  : "transparent",
                                            }}
                                            onClick={() =>
                                              handlePrantRowClick(
                                                vibhag._id,
                                                null,
                                                "vibhag"
                                              )
                                            }
                                          >
                                            <td>
                                              <Button
                                                variant="link"
                                                onClick={() =>
                                                  toggleVibhag(
                                                    vibhag.vibhag_name
                                                  )
                                                }
                                              >
                                                {translatedVibhag}
                                              </Button>
                                            </td>
                                            {fieldNames.map(
                                              (fieldName, index) => (
                                                <td key={index}>
                                                  {calculateTotals(
                                                    [vibhag],
                                                    fieldName
                                                  ) || "-"}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                          {/* jila_row added */}
                                          <tr>
                                            <td colSpan={fieldNames.length + 1}>
                                              <Collapse
                                                in={
                                                  openVibhag[vibhag.vibhag_name]
                                                }
                                              >
                                                <div>
                                                  <Table
                                                    bordered
                                                    size="sm"
                                                    className="custom-table"
                                                  >
                                                    <tbody>
                                                      {vibhag.jilas &&
                                                      vibhag.jilas.length >
                                                        0 ? (
                                                        vibhag.jilas.map(
                                                          (jila) => {
                                                            const translatedJila =
                                                              translateName(
                                                                jila.jila_name,
                                                                JilaTranslation
                                                              );
                                                            return (
                                                              <tr
                                                                key={jila._id}
                                                                className="jila-row"
                                                                style={{
                                                                  backgroundColor:
                                                                    jila._id
                                                                      ? "#f4a261"
                                                                      : "transparent",
                                                                }}
                                                                onClick={() =>
                                                                  handlePrantRowClick(
                                                                    jila._id,
                                                                    null,
                                                                    "jila"
                                                                  )
                                                                }
                                                              >
                                                                <td>
                                                                  <Button variant="link">
                                                                    {
                                                                      translatedJila
                                                                    }
                                                                  </Button>
                                                                </td>
                                                                {fieldNames.map(
                                                                  (
                                                                    fieldName,
                                                                    index
                                                                  ) => (
                                                                    <td
                                                                      key={
                                                                        index
                                                                      }
                                                                    >
                                                                      {getNestedData(
                                                                        jila,
                                                                        fieldName
                                                                      ) || "-"}
                                                                    </td>
                                                                  )
                                                                )}
                                                              </tr>
                                                            );
                                                          }
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            colSpan={
                                                              fieldNames.length +
                                                              1
                                                            }
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                            }}
                                                          >
                                                            No Jila Available
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </Table>
                                                </div>
                                              </Collapse>
                                            </td>
                                          </tr>
                                          {/* jila_row end */}
                                        </React.Fragment>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </Collapse>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {/* Grand Total Row */}
                  <tr className="grand-total-row">
                    <td>
                      <strong>{fieldLabels[language]?.GrandTotal}</strong>
                    </td>
                    {fieldNames.map((fieldName, index) => (
                      <td key={index}>
                        <strong>
                          {calculateTotals(item.prants, fieldName)}
                        </strong>
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              );
            }

            // return (
            //   <React.Fragment key={item._id}>
            //     {item.kshetras.map((kshettra) => (
            //       <React.Fragment key={kshettra._id}>
            //         <tr
            //           className="kshettra-row"
            //           style={{
            //             backgroundColor: selectedKshettraId === kshettra._id ? "#dcbc44" : "transparent",
            //           }}
            //           onClick={() => handlePrantRowClick(kshettra._id, null, "kshetra")}
            //         >
            //           <td>
            //             <Button variant="link" onClick={() => toggleKshettra(kshettra.kshetra_name)}>
            //               {kshettra.kshetra_name}
            //             </Button>
            //           </td>
            //           {fieldNames.map((fieldName, index) => (
            //             <td key={index}>{calculateTotals([kshettra], fieldName) || "-"}</td>
            //           ))}
            //         </tr>
            //       </React.Fragment>
            //     ))}
            //     <tr className="grand-total-row">
            //       <td><strong>{fieldLabels[language]?.GrandTotal}</strong></td>
            //       {fieldNames.map((fieldName, index) => (
            //         <td key={index}><strong>{calculateTotals(item.kshetras, fieldName)}</strong></td>
            //       ))}
            //     </tr>
            //   </React.Fragment>
            // );
          })}
        </tbody>

        {user.user_type === "kendra" && (
          <tbody>
            {data.map((kendra) =>
              kendra.kshetras.map((kshettra, index) => {
                const translatedKshetra = translateName(
                  kshettra.kshetra_name,
                  kshetraTranslation
                );
                return (
                  <React.Fragment key={kshettra._id}>
                    <tr
                      className="kshettra-row"
                      style={{
                        backgroundColor:
                          selectedKshettraId === kshettra._id
                            ? "#eeaeca"
                            : "transparent",
                      }}
                      onClick={() =>
                        handlePrantRowClick(kshettra._id, index, "kshettra")
                      }
                    >
                      <td>
                        <Button
                          variant="link"
                          onClick={() => toggleKshettra(kshettra.kshetra_name)}
                        >
                          {translatedKshetra}
                        </Button>
                      </td>
                      {fieldNames.map((fieldName, index) => (
                        <td key={index}>
                          {calculateTotals([kshettra], fieldName) || "-"}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <td colSpan={fieldNames.length + 1}>
                        <Collapse in={openKshettra[kshettra.kshetra_name]}>
                          <div>
                            <Table bordered size="sm" className="custom-table">
                              <tbody>
                                {kshettra.prants.map((prant, index) => {
                                  const translatedPrant = translateName(
                                    prant.prant_name,
                                    PrantTranslation
                                  );
                                  return (
                                    <React.Fragment key={prant._id}>
                                      <tr
                                        className="prant-row"
                                        style={{
                                          backgroundColor:
                                            selectedPrantId === prant._id
                                              ? "#42cef5"
                                              : "transparent",
                                        }}
                                        onClick={() =>
                                          handlePrantRowClick(
                                            prant._id,
                                            index,
                                            "prant"
                                          )
                                        }
                                      >
                                        <td>
                                          <Button
                                            variant="link"
                                            onClick={() =>
                                              togglePrant(prant.prant_name)
                                            }
                                          >
                                            {translatedPrant}
                                          </Button>
                                        </td>
                                        {fieldNames.map((fieldName, index) => (
                                          <td key={index}>
                                            {calculateTotals(
                                              [prant],
                                              fieldName
                                            ) || "-"}
                                          </td>
                                        ))}
                                      </tr>
                                      <tr>
                                        <td colSpan={fieldNames.length + 1}>
                                          <Collapse
                                            in={openPrant[prant.prant_name]}
                                          >
                                            <div>
                                              <Table
                                                bordered
                                                size="sm"
                                                className="custom-table"
                                              >
                                                <tbody>
                                                  {prant.vibhags.map(
                                                    (vibhag, index) => {
                                                      const translatedVibhag =
                                                        translateName(
                                                          vibhag.vibhag_name,
                                                          VibhagTranslation
                                                        );
                                                      return (
                                                        <React.Fragment
                                                          key={vibhag._id}
                                                        >
                                                          <tr
                                                            className="vibhag-row"
                                                            style={{
                                                              backgroundColor:
                                                                selectedVibhagId ===
                                                                vibhag._id
                                                                  ? "#907c56"
                                                                  : "transparent",
                                                            }}
                                                            onClick={() =>
                                                              handlePrantRowClick(
                                                                vibhag._id,
                                                                index,
                                                                "vibhag"
                                                              )
                                                            }
                                                          >
                                                            <td>
                                                              <Button
                                                                variant="link"
                                                                onClick={() =>
                                                                  toggleVibhag(
                                                                    vibhag.vibhag_name
                                                                  )
                                                                }
                                                              >
                                                                {
                                                                  translatedVibhag
                                                                }
                                                              </Button>
                                                            </td>
                                                            {fieldNames.map(
                                                              (
                                                                fieldName,
                                                                index
                                                              ) => (
                                                                <td key={index}>
                                                                  {calculateTotals(
                                                                    [vibhag],
                                                                    fieldName
                                                                  ) || "-"}
                                                                </td>
                                                              )
                                                            )}
                                                          </tr>
                                                          <tr>
                                                            <td
                                                              colSpan={
                                                                fieldNames.length +
                                                                1
                                                              }
                                                            >
                                                              <Collapse
                                                                in={
                                                                  openVibhag[
                                                                    vibhag
                                                                      .vibhag_name
                                                                  ]
                                                                }
                                                              >
                                                                <div>
                                                                  <Table
                                                                    bordered
                                                                    size="sm"
                                                                    className="custom-table"
                                                                  >
                                                                    <tbody>
                                                                      {vibhag.jilas.map(
                                                                        (
                                                                          jila
                                                                        ) => {
                                                                          const translatedJila =
                                                                            translateName(
                                                                              jila.jila_name,
                                                                              JilaTranslation
                                                                            );
                                                                          return (
                                                                            <tr
                                                                              key={
                                                                                jila._id
                                                                              }
                                                                              className="jila-row"
                                                                            >
                                                                              <td>
                                                                                {
                                                                                  translatedJila
                                                                                }
                                                                              </td>
                                                                              {fieldNames.map(
                                                                                (
                                                                                  fieldName,
                                                                                  index
                                                                                ) => (
                                                                                  <td
                                                                                    key={
                                                                                      index
                                                                                    }
                                                                                  >
                                                                                    {getNestedData(
                                                                                      jila,
                                                                                      fieldName
                                                                                    )}
                                                                                  </td>
                                                                                )
                                                                              )}
                                                                            </tr>
                                                                          );
                                                                        }
                                                                      )}
                                                                    </tbody>
                                                                  </Table>
                                                                </div>
                                                              </Collapse>
                                                            </td>
                                                          </tr>
                                                        </React.Fragment>
                                                      );
                                                    }
                                                  )}
                                                </tbody>
                                              </Table>
                                            </div>
                                          </Collapse>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        </Collapse>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })
            )}
            {/* Grand Total Row */}
            <tr>
              <td className="fixed-header">
                {fieldLabels[language]?.GrandTotal}
              </td>
              {fieldNames.map((fieldName, index) => (
                <td key={index}>{calculateGrandTotal(fieldName) || "-"}</td>
              ))}
            </tr>
          </tbody>
        )}
      </Table>
    </Container>
  );
};

export default CollapsibleTable;
